import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../i18n"; // <-- наш настоящий instance

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  // t берём из react-i18next
  const { t } = useTranslation();

  // ✅ форс-рендер при смене языка (чтобы мобилка и десктоп всегда одинаково)
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const language = useMemo(() => {
    const lng = i18n?.resolvedLanguage || i18n?.language || "en";
    return String(lng).split("-")[0];
  }, [langTick]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
    // setMenuOpen(false); // если хочешь закрывать меню на мобиле после выбора
  };

  const navLinks = useMemo(
    () => [
      { name: t("nav.about"), href: "#about" },
      { name: t("nav.solutions"), href: "#solutions" },
      { name: t("nav.references"), href: "#references" },
      { name: t("nav.jobs"), to: "/jobs" },
      { name: t("nav.contact"), href: "#contact" },
    ],
    // ✅ пересчитываем при смене языка
    [t, language]
  );

  const LanguageButtons = ({ className = "" }) => (
    <div className={className}>
      <button
        className={`${
          language === "en"
            ? "text-blue-600 font-semibold"
            : "hover:text-gray-500"
        }`}
        onClick={() => handleLanguageChange("en")}
        type="button"
      >
        EN
      </button>
      <button
        className={`${
          language === "de"
            ? "text-blue-600 font-semibold"
            : "hover:text-gray-500"
        }`}
        onClick={() => handleLanguageChange("de")}
        type="button"
      >
        DE
      </button>
    </div>
  );

  return (
    <nav className="bg-white text-black shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between p-6">
        <div className="text-2xl font-bold">
          <button
            onClick={() => navigate("/")}
            className="hover:text-gray-300"
            aria-label="Go to homepage"
            type="button"
          >
            <img
              src={`${process.env.PUBLIC_URL}/logos/Sharklogo.png`}
              alt="SHARK company logo"
              className="h-5"
            />
          </button>
        </div>

        <ul className="hidden md:flex space-x-8">
          {navLinks.map((link, index) => (
            <li key={index}>
              {link.to ? (
                <Link to={link.to} className="hover:text-blue-500">
                  {link.name}
                </Link>
              ) : (
                <a href={link.href} className="hover:text-blue-500">
                  {link.name}
                </a>
              )}
            </li>
          ))}
        </ul>

        <LanguageButtons className="hidden md:flex items-center space-x-4" />

        <button
          className="md:hidden text-black focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          type="button"
        >
          {menuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-menu"
            >
              <line x1="4" x2="20" y1="12" y2="12" />
              <line x1="4" x2="20" y1="6" y2="6" />
              <line x1="4" x2="20" y1="18" y2="18" />
            </svg>
          )}
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t">
          <ul className="flex flex-col space-y-4 p-6">
            {navLinks.map((link, index) => (
              <li key={index}>
                {link.to ? (
                  <Link
                    to={link.to}
                    className="hover:text-blue-500"
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.name}
                  </Link>
                ) : (
                  <a
                    href={link.href}
                    className="hover:text-blue-500"
                    onClick={() => setMenuOpen(false)}
                  >
                    {link.name}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <LanguageButtons className="flex justify-center space-x-4 pb-6" />
        </div>
      )}
    </nav>
  );
};

export default Header;









